import React from "react";
import webicon from "../img/logo.png";
import "../style/navbar.css";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFacebookF, faTwitter } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope, faPhone } from "@fortawesome/free-solid-svg-icons";

const Navbar = () => {
  const menuItems = [
  { label: "Home", to: "/" },
  { label: "Products", to: "/Product" },
  { label: "Customize Software", to: "/custom" },
  { label: "Web & Mobile App", to: "/website" },
  { label: "Software Outsourcing", to: "/outsourcing" },
  { label: "Job Openings", to: "/job-openings" },
  { label: "About Us", to: "/About" },
  { label: "Contact Us", to: "/EmailContactForm" },
  { label: "Request for Demo", to: "/demo" },
];

  return (
    <header className="ebs-site-header">
      <div className="ebs-topbar">
        <div className="container-fluid ebs-topbar-inner">
          <div className="ebs-topbar-left">
            <a href="mailto:info@ebssoftware.co.in">
              <FontAwesomeIcon icon={faEnvelope} />
              <span>info@ebssoftware.co.in</span>
            </a>

            <a href="tel:+919932013501">
              <FontAwesomeIcon icon={faPhone} />
              <span>+91 99320 13501</span>
            </a>
          </div>

          <div className="ebs-topbar-right">
            <strong>GSTIN No: 19AJAPM8399K1ZE</strong>

            <a
              href="https://www.facebook.com/EBSSoftware/"
              target="_blank"
              rel="noreferrer"
              aria-label="Facebook"
            >
              <FontAwesomeIcon icon={faFacebookF} />
            </a>

            <a
              href="https://twitter.com/EbsSoftware"
              target="_blank"
              rel="noreferrer"
              aria-label="Twitter"
            >
              <FontAwesomeIcon icon={faTwitter} />
            </a>
          </div>
        </div>
      </div>

      <nav className="navbar navbar-expand-lg ebs-main-navbar">
        <div className="container-fluid ebs-navbar-inner">
          <NavLink className="navbar-brand ebs-brand" to="/">
            <img src={webicon} alt="EBS Software Solution" />
            <span>EBS Software Solution</span>
          </NavLink>

          <button
            className="navbar-toggler ebs-navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#ebsNavbar"
            aria-controls="ebsNavbar"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="collapse navbar-collapse ebs-navbar-collapse"
            id="ebsNavbar"
          >
            <ul className="navbar-nav ms-auto ebs-menu">
              {menuItems.map((item) => (
                <li className="nav-item" key={item.to}>
                  <NavLink
                    to={item.to}
                    end={item.to === "/"}
                    className={({ isActive }) =>
                      isActive ? "nav-link active" : "nav-link"
                    }
                  >
                    {item.label}
                  </NavLink>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </nav>

      <div className="ebs-salesbar">
        <div className="container-fluid ebs-salesbar-inner">
          <span>
            Sales. <strong>+91 97337 21111</strong>
          </span>
          <span>
            Email. <strong>info@ebssoftware.co.in</strong>
          </span>
          <span>
            GSTIN: <strong>19AJAPM8399K1ZE</strong>
          </span>
        </div>
      </div>
    </header>
  );
};

export default Navbar;
